import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AuthContinuation from './AuthContinuation';
import ErrorBoundary from './app/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const isAuthContinuation = window.location.pathname === '/auth/continue';
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      {isAuthContinuation ? <AuthContinuation /> : <App />}
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
